import { motion } from "framer-motion";
import { Eyebrow } from "./Shared";
import { PhotoSlot } from "./PhotoSlot";

// Hero animates on mount (not on scroll) so it is never stuck invisible above the fold.
const enter = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function Hero() {
  return (
    <section id="top" className="flex min-h-screen items-center bg-navy pb-20 pt-32 lg:pb-28 lg:pt-40">
      <div className="mx-auto grid w-full max-w-[1200px] items-center gap-14 px-6 lg:grid-cols-[1.05fr_0.95fr]">
        <div>
          <motion.div {...enter()}>
            <Eyebrow>Founder & CEO, u-topia</Eyebrow>
            <h1 className="mt-5 text-5xl font-semibold leading-[1.05] tracking-[-0.02em] text-white sm:text-6xl lg:text-7xl">
              Emmanuel
              <br />
              Quezada
            </h1>
            <p className="mt-6 text-xl font-medium text-brand-orange sm:text-2xl">
              Social innovator. Systems thinker. Builder of rails.
            </p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
              He is building the financial super app the world actually needs: wallets, cards,
              and stablecoin rails as simple as sending a message, and a community school so
              the people who use the system own it.
            </p>
          </motion.div>

          <motion.div {...enter(0.15)}>
            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-start-conversation"
                className="rounded-full bg-brand-orange px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-orange-light"
              >
                Start a conversation
              </a>
              <a
                href="#building"
                data-testid="hero-cta-see-work"
                className="rounded-full border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-white"
              >
                See what he is building
              </a>
            </div>
        </motion.div>
        </div>

        <motion.div {...enter(0.2)} className="lg:justify-self-end">
          <PhotoSlot
            slotId="IMG_HERO"
            aspect="aspect-[4/5]"
            className="w-full max-w-[520px]"
            eager
          />
          <div
            aria-hidden="true"
            className="ml-auto mt-4 h-1.5 w-2/3 rounded-full bg-gradient-to-r from-brand-orange to-brand-orange-light"
          />
        </motion.div>
      </div>
    </section>
  );
}
